import { Stack } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  width?: string | number;
}

const VerticalNavigationWrapper = ({ width, children }: PropsWithChildren<Props>) => (
  <Stack spacing={2} sx={{ py: 2.5, px: 2, overflow: "auto", width: width ?? "19rem" }}>
    {children}
  </Stack>
);

export default VerticalNavigationWrapper;
